// Dependencies
import React, { Component } from 'react';
import { isMobileOnly } from 'react-device-detect';

// Primereact imports
import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';

// Styling
import './professional-data.scss';

// Multi lang
import { getLanguage, withTranslation } from 'react-multi-lang';

// Utils
import { COUNCIL_LIST, DCF_LIST, DISTRICT_LIST } from '../../../common/lists/dcf';
import { CLINIC_ACTIVITY_LIST, getMainActivityContextList, getMainActivityContractList, getMainActivityList, getNumHoursList, getNumWorkspacesList, getTranslatedMainActivityContextOption, getTranslatedMainActivityContractOption, getTranslatedMainActivityOption, getTranslatedNumHoursOption, getTranslatedNumWorkplacesOption, getTranslatedTypeWorkOption, getTypeWorkList, SECONDARY_ACTIVITY_CONTEXT } from '../../../common/lists/professional';
import { convertBase64ToArrayBuffer, downloadFile } from '../../../common/utils/download-utils';
import { getRegistrationDoc } from '../../../common/utils/registration-utils';
import { formatAssociateDataToService } from '../../../common/formatters/associate';
import { formatYesNoDropdownLists, getYesNoDropdownList } from '../../../common/utils/form-data-utils';
import { STREET_TYPE_LIST } from '../../../common/lists/personal';
import { DOC_TYPE_GOOD_STANDING, DOC_TYPE_PROFESSIONAL_ADDRESS, PROFESSIONAL, YES_OPTION } from '../../../common/constants';

// Redux
import { connect } from 'react-redux';
import ProfileService from '../../../redux/services/profile';
import DocumentService from '../../../redux/services/document';
import { getAssociateData, setEditMode } from '../../../redux/actions/profile';
import { getPhysioPostGradAreaList, getTranslatedPhysioPostGradAreaOption } from '../../../common/lists/qualification';

const CA_PROPS = [
    'cardioRespiratory', 'muscleHealth', 'muscleAmputees', 'muscleTMJ',
    'neuroHealth', 'neuroVestibular', 'dermaHealth', 'mentalHealth',
    'womensHealth', 'pelvicHealth', 'sportsHealth', 'oncology',
    'palliativeCare', 'occupational', 'emergencyDisaster', 'animalHealth',
    'publicHealth', 'communityHealth', 'schoolHealth', 'pediatrics',
    'gerontology', 'pain', 'intensiveCare', 'healthProtection'
];

class ProfessionalDataComponent extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            readOnlyMode: true,
            professionalExperience: null,
            entity: "",
            streetType: null,
            streetTypePlaceholder: "",
            addressLine: "",
            doorNumber: "",
            doorFloor: "",
            auxPlace: "",
            cP4: "",
            cP3: "",
            city: "",
            county: null,
            district: null,
            mainActivity: null,
            mainActivityContext: null,
            mainActivityContract: null,
            secondaryActivity: null,
            secondaryActivityContext: null,
            professionalExerciseType: null,
            mainActivityArea: null,
            workplacesNumber: null,
            weeklyHours: null,
            goodStandingAttachment: null,
            compProfessionalAttachment: null,
            goodStandingAttachmentName: "",
            compProfessionalAttachmentName: "",
            goodStandingDoc: null,
            compProfessionalDoc: null,
            hasClinicActivity: null,
            clinicActivity: null,
            // Mandatory fields validation
            validAddressLine: true,
            validDoorNumber: true,
            validCp: true,
            validCpFormat: true,
            validCity: true,
            validSecondaryActivityContext: true,
            validClinicActivity: true,
            validUploadFile: true,
            validEntity: true,
            validMainActivity: true,
            validMainActivityContract: true,
            validMainActivityContext: true,
            validMainActivityArea: true,
            validProfessionalExerciseType: true,
            validWorkplacesNumber: true,
            validWeeklyHours: true,
            validCompProfessionalDoc: true
        };
    }

    componentDidMount() {
        this.setState({
            professionalExperience: this.props.associate.professionalData.professionalExperience,
            entity: this.props.associate.professionalData.entity,
            streetType: this.props.associate.professionalData.streetType,
            streetTypePlaceholder: this.props.associate.professionalData.streetTypePlaceholder,
            addressLine: this.props.associate.professionalData.addressLine,
            doorNumber: this.props.associate.professionalData.doorNumber,
            doorFloor: this.props.associate.professionalData.doorFloor,
            auxPlace: this.props.associate.professionalData.auxPlace,
            cP4: this.props.associate.professionalData.cP4,
            cP3: this.props.associate.professionalData.cP3,
            city: this.props.associate.professionalData.city,
            county: this.props.associate.professionalData.county,
            district: this.props.associate.professionalData.district,
            mainActivity: this.props.associate.professionalData.mainActivity,
            mainActivityContext: this.props.associate.professionalData.mainActivityContext,
            mainActivityContract: this.props.associate.professionalData.mainActivityContract,
            mainActivityArea: this.props.associate.professionalData.mainActivityArea,
            secondaryActivity: this.props.associate.professionalData.secondaryActivity,
            secondaryActivityContext: this.props.associate.professionalData.secondaryActivityContext,
            professionalExerciseType: this.props.associate.professionalData.professionalExerciseType,
            workplacesNumber: this.props.associate.professionalData.workplacesNumber,
            weeklyHours: this.props.associate.professionalData.weeklyHours,
            hasClinicActivity: this.props.associate.professionalData.hasClinicActivity,
            clinicActivity: this.props.associate.professionalData.clinicActivity,
            compProfessionalDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_PROFESSIONAL_ADDRESS),
            goodStandingDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_GOOD_STANDING)
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.language !== prevProps.language) {
            this.reloadFormData();
        }
    }

    downloadDocument(documentRef) {
        DocumentService.downloadDocument(documentRef)
          .then((response) => {
                var blob = new Blob([convertBase64ToArrayBuffer(response.fileContent)], { type: response.contentType });
                downloadFile(URL.createObjectURL(blob), response.filename);
          })
          .catch(error => {
              this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
          });
    }

    activateEditMode() {
        this.setState({
            readOnlyMode: false
        });

        this.props.setEditMode(true);
    }

    cancelEditMode() {
        this.reloadFormData();
        this.props.setEditMode(false);

        this.setState({
            readOnlyMode: true
        });
    }

    reloadFormData() {
        let associate = this.formatProfessionalDataFormValues(this.props.associate, this.props.language);

        this.setState({
            professionalExperience: associate.professionalData.professionalExperience,
            entity: this.props.associate.professionalData.entity,
            streetType: associate.professionalData.streetType,
            streetTypePlaceholder: this.props.associate.professionalData.streetTypePlaceholder,
            addressLine: this.props.associate.professionalData.addressLine,
            doorNumber: this.props.associate.professionalData.doorNumber,
            doorFloor: this.props.associate.professionalData.doorFloor,
            auxPlace: this.props.associate.professionalData.auxPlace,
            cP4: this.props.associate.professionalData.cP4,
            cP3: this.props.associate.professionalData.cP3,
            city: this.props.associate.professionalData.city,
            county: associate.professionalData.county,
            district: associate.professionalData.district,
            mainActivity: associate.professionalData.mainActivity,
            mainActivityContext: associate.professionalData.mainActivityContext,
            mainActivityContract: associate.professionalData.mainActivityContract,
            mainActivityArea: associate.professionalData.mainActivityArea,
            secondaryActivity: associate.professionalData.secondaryActivity,
            secondaryActivityContext: associate.professionalData.secondaryActivityContext,
            professionalExerciseType: associate.professionalData.professionalExerciseType,
            workplacesNumber: associate.professionalData.workplacesNumber,
            weeklyHours: associate.professionalData.weeklyHours,
            hasClinicActivity: associate.professionalData.hasClinicActivity,
            clinicActivity: this.props.associate.professionalData.clinicActivity,
            readOnlyMode: true
        });
    }

    saveChanges() {
        if(this.validateForm()) {
            let associate = this.props.associate;
            associate.professionalData = {
                professionalExperience: this.state.professionalExperience,
                entity: this.state.entity,
                streetType: this.state.streetType,
                streetTypePlaceholder: this.state.streetTypePlaceholder,
                addressLine: this.state.addressLine,
                doorNumber: this.state.doorNumber,
                doorFloor: this.state.doorFloor,
                auxPlace: this.state.auxPlace,
                cP4: this.state.cP4,
                cP3: this.state.cP3,
                city: this.state.city,
                county: this.state.county,
                district: this.state.district,
                mainActivity: this.state.mainActivity,
                mainActivityContext: this.state.mainActivityContext,
                mainActivityContract: this.state.mainActivityContract,
                mainActivityArea: this.state.mainActivityArea,
                secondaryActivity: this.state.secondaryActivity,
                secondaryActivityContext: this.state.secondaryActivityContext,
                professionalExerciseType: this.state.professionalExerciseType,
                workplacesNumber: this.state.workplacesNumber,
                weeklyHours: this.state.weeklyHours,
                hasClinicActivity: this.state.hasClinicActivity,
                clinicActivity: this.state.clinicActivity
            };

            ProfileService.updateAssociateData(formatAssociateDataToService(associate), this.props.t('general.update-record'), PROFESSIONAL)
            .then((response) => {

                if(this.state.compProfessionalAttachment !== null) {
                    ProfileService.uploadAssociateDocument(this.state.compProfessionalAttachment, this.props.registrationRef.toString(), DOC_TYPE_PROFESSIONAL_ADDRESS)
                    .then((response) => {
                        this.props.getAssociateData(this.props.registrationRef);

                        setTimeout(() => {
                            this.setState({
                                associate: this.props.associate,
                                compProfessionalDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_PROFESSIONAL_ADDRESS)
                            });
                        }, 1500);
                    })
                    .catch(error => {
                        this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
                    });
                }

                if(this.state.goodStandingAttachment !== null) {
                    ProfileService.uploadAssociateDocument(this.state.goodStandingAttachment, this.props.registrationRef.toString(), DOC_TYPE_GOOD_STANDING)
                    .then((response) => {
                        this.props.getAssociateData(this.props.registrationRef);

                        setTimeout(() => {
                            this.setState({
                                associate: this.props.associate,
                                goodStandingDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_GOOD_STANDING)
                            });
                        }, 1500);
                    })
                    .catch(error => {
                        this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
                    });
                }

                if(this.state.compProfessionalAttachment === null && this.state.goodStandingAttachment === null) {
                    this.props.getAssociateData(this.props.registrationRef);

                    setTimeout(() => {
                        this.setState({
                            associate: this.props.associate
                        });
                    }, 1500);
                }

                this.setState({
                    readOnlyMode: true
                });
    
                this.props.setEditMode(false);
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
            });
        }
    }

    validateForm() {
        let validationResult = true;
        
        // Postal code custom validation
        let validCp = (this.state.cP4 !== "" && this.state.cP3 !== "");
        let validCpFormat = true;

        if(validCp) {
            validCpFormat = (this.state.cP4.match(/^[0-9]+$/) !== null) && (this.state.cP3.match(/^[0-9]+$/) !== null);
        }

        // Secondary activity context validation
        let validSecondaryActivityContext = true;

        if(this.state.secondaryActivity.code === YES_OPTION.code) {
            validSecondaryActivityContext = this.state.secondaryActivityContext !== null;
        }

        // Clinic activity validation
        let validClinicActivity = true;

        if(this.state.hasClinicActivity.code === YES_OPTION.code) {
            validClinicActivity = CA_PROPS.some(prop =>
                this.state.clinicActivity[`${prop}Activities`].length > 0
            );
        }

        // Professional experience mandatory fields validation
        let validMainActivity = true;
        let validMainActivityContract = true;
        let validMainActivityContext = true;
        let validMainActivityArea = true;
        let validProfessionalExerciseType = true;
        let validWorkplacesNumber = true;
        let validWeeklyHours = true;
        let validCompProfessionalDoc = true;

        if(this.state.professionalExperience.code === YES_OPTION.code) {
            validMainActivity = this.state.mainActivity !== null && !!this.state.mainActivity.code;
            validMainActivityContract = this.state.mainActivityContract !== null && !!this.state.mainActivityContract.code;
            validMainActivityContext = this.state.mainActivityContext !== null && !!this.state.mainActivityContext.code;
            validMainActivityArea = this.state.mainActivityArea !== null && !!this.state.mainActivityArea.code;
            validProfessionalExerciseType = this.state.professionalExerciseType !== null && !!this.state.professionalExerciseType.code;
            validWorkplacesNumber = this.state.workplacesNumber !== null && !!this.state.workplacesNumber.code;
            validWeeklyHours = this.state.weeklyHours !== null && !!this.state.weeklyHours.code;
            validCompProfessionalDoc = this.state.compProfessionalDoc !== null || this.state.compProfessionalAttachment !== null;
        }

        this.setState({
            validEntity: this.state.entity !== "",
            validAddressLine: this.state.addressLine !== "",
            validDoorNumber: this.state.doorNumber !== "",
            validCity: this.state.city !== "",
            validCp: validCp,
            validCpFormat: validCpFormat,
            validSecondaryActivityContext: validSecondaryActivityContext,
            validClinicActivity: validClinicActivity,
            validMainActivity: validMainActivity,
            validMainActivityContract: validMainActivityContract,
            validMainActivityContext: validMainActivityContext,
            validMainActivityArea: validMainActivityArea,
            validProfessionalExerciseType: validProfessionalExerciseType,
            validWorkplacesNumber: validWorkplacesNumber,
            validWeeklyHours: validWeeklyHours,
            validCompProfessionalDoc: validCompProfessionalDoc
        });

        validationResult = (this.state.entity !== "" &&
                            this.state.addressLine !== "" &&
                            this.state.doorNumber !== "" &&
                            this.state.city !== "" &&
                            validCp &&
                            validCpFormat &&
                            validSecondaryActivityContext &&
                            validClinicActivity &&
                            validMainActivity &&
                            validMainActivityContract &&
                            validMainActivityContext &&
                            validMainActivityArea &&
                            validProfessionalExerciseType &&
                            validWorkplacesNumber &&
                            validWeeklyHours &&
                            validCompProfessionalDoc);

        return validationResult;
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        });

        if(column === "county") {
            for (let i = 0; i < DCF_LIST.length; i++) {
                if(DCF_LIST[i].council === value.code) {
                    this.setState({
                        district: { code: DCF_LIST[i].district, name: DCF_LIST[i].district }
                    });
                }
            }
        }
        else if(column === "streetType") {
            this.setState({
                streetTypePlaceholder: value.name
            });
        }
    }

    updateClinicActivityFormComponent(column, value) {
        let clinicActivity = this.state.clinicActivity;
        clinicActivity[column] = value;

        this.setState({
            clinicActivity: clinicActivity
        });
    }

    uploadDocumentHandler(document, documentType) {
        let self = this;
        var reader = new FileReader();
        reader.readAsBinaryString(document[0]);

        reader.onload = function() {
            if(documentType === "good_standing") {
                self.setState({
                    goodStandingAttachment: btoa(reader.result),
                    goodStandingAttachmentName: document[0].name,
                    validUploadFile: true
                });
            }
            else {
                self.setState({
                    compProfessionalAttachment: btoa(reader.result),
                    compProfessionalAttachmentName: document[0].name,
                    validUploadFile: true
                });
            }
        };
    }

    formatProfessionalDataFormValues(sourceAssociate, language="pt") {
        
        let associate = {
            professionalData: {
                clinicActivity: {}
            }
        };

        if(typeof sourceAssociate.professionalData.professionalExperience !== 'object' && sourceAssociate.professionalData.professionalExperience !== null) {
            associate.professionalData.professionalExperience = formatYesNoDropdownLists(sourceAssociate.professionalData.professionalExperience, language);
        }
        else if (typeof sourceAssociate.professionalData.professionalExperience  === 'object' && sourceAssociate.professionalData.professionalExperience !== null) {
            associate.professionalData.professionalExperience = formatYesNoDropdownLists(sourceAssociate.professionalData.professionalExperience.code === YES_OPTION.code, language);
        }
    
        if(typeof sourceAssociate.professionalData.streetType !== 'object' && sourceAssociate.professionalData.streetType !== null) {
            associate.professionalData.streetType = { name: sourceAssociate.professionalData.streetTypePlaceholder, code: sourceAssociate.professionalData.streetType };
        }
        else {
            associate.professionalData.streetType = sourceAssociate.professionalData.streetType;
        }
    
        if(typeof sourceAssociate.professionalData.county !== 'object' && sourceAssociate.professionalData.county !== null) {
            associate.professionalData.county = { name: sourceAssociate.professionalData.county, code: sourceAssociate.professionalData.county };
        }
        else {
            associate.professionalData.county = sourceAssociate.professionalData.county;
        }

        if(typeof sourceAssociate.professionalData.district !== 'object' && sourceAssociate.professionalData.district !== null) {
            associate.professionalData.district = { name: sourceAssociate.professionalData.district, code: sourceAssociate.professionalData.district };
        }
        else {
            associate.professionalData.district = sourceAssociate.professionalData.district;
        }
    
        if(typeof sourceAssociate.professionalData.mainActivity !== 'object' && sourceAssociate.professionalData.mainActivity !== null) {
            associate.professionalData.mainActivity = { name: sourceAssociate.professionalData.mainActivity, code: sourceAssociate.professionalData.mainActivity };
        }
        else if (typeof sourceAssociate.professionalData.mainActivity === 'object' && sourceAssociate.professionalData.mainActivity !== null) {
            associate.professionalData.mainActivity = getTranslatedMainActivityOption(sourceAssociate.professionalData.mainActivity.code, language);
        }
    
        if(typeof sourceAssociate.professionalData.mainActivityContext !== 'object' && sourceAssociate.professionalData.mainActivityContext !== null) {
            associate.professionalData.mainActivityContext = { name: sourceAssociate.professionalData.mainActivityContext, code: sourceAssociate.professionalData.mainActivityContext };
        }
        else if (typeof sourceAssociate.professionalData.mainActivityContext === 'object' && sourceAssociate.professionalData.mainActivityContext !== null) {
            associate.professionalData.mainActivityContext = getTranslatedMainActivityContextOption(sourceAssociate.professionalData.mainActivityContext.code, language);
        }
    
        if(typeof sourceAssociate.professionalData.mainActivityContract !== 'object' && sourceAssociate.professionalData.mainActivityContract !== null) {
            associate.professionalData.mainActivityContract = { name: sourceAssociate.professionalData.mainActivityContract, code: sourceAssociate.professionalData.mainActivityContract };
        }
        else if (typeof sourceAssociate.professionalData.mainActivityContract === 'object' && sourceAssociate.professionalData.mainActivityContract !== null) {
            associate.professionalData.mainActivityContract = getTranslatedMainActivityContractOption(sourceAssociate.professionalData.mainActivityContract.code, language);
        }
    
        if(typeof sourceAssociate.professionalData.mainActivityArea !== 'object' && sourceAssociate.professionalData.mainActivityArea !== null) {
            associate.professionalData.mainActivityArea = { name: sourceAssociate.professionalData.mainActivityArea, code: sourceAssociate.professionalData.mainActivityArea };
        }
        else if (typeof sourceAssociate.professionalData.mainActivityArea === 'object' && sourceAssociate.professionalData.mainActivityArea !== null) {
            associate.professionalData.mainActivityArea = getTranslatedPhysioPostGradAreaOption(sourceAssociate.professionalData.mainActivityArea.code, language);
        }
    
        if(typeof sourceAssociate.professionalData.secondaryActivity !== 'object' && sourceAssociate.professionalData.secondaryActivity !== null) {
            associate.professionalData.secondaryActivity = formatYesNoDropdownLists(sourceAssociate.professionalData.secondaryActivity);
        }
        else if (typeof sourceAssociate.professionalData.secondaryActivity  === 'object' && sourceAssociate.professionalData.secondaryActivity !== null) {
            associate.professionalData.secondaryActivity = formatYesNoDropdownLists(sourceAssociate.professionalData.secondaryActivity.code === YES_OPTION.code, language);
        }
    
        if(typeof sourceAssociate.professionalData.hasClinicActivity !== 'object' && sourceAssociate.professionalData.hasClinicActivity !== null) {
            associate.professionalData.hasClinicActivity = formatYesNoDropdownLists(sourceAssociate.professionalData.hasClinicActivity);
        }
        else if (typeof sourceAssociate.professionalData.hasClinicActivity  === 'object' && sourceAssociate.professionalData.hasClinicActivity !== null) {
            associate.professionalData.hasClinicActivity = formatYesNoDropdownLists(sourceAssociate.professionalData.hasClinicActivity.code === YES_OPTION.code, language);
        }
    
        if(typeof sourceAssociate.professionalData.professionalExerciseType !== 'object' && sourceAssociate.professionalData.professionalExerciseType !== null) {
            associate.professionalData.professionalExerciseType = { name: sourceAssociate.professionalData.professionalExerciseType, code: sourceAssociate.professionalData.professionalExerciseType };
        }
        else if (typeof sourceAssociate.professionalData.professionalExerciseType === 'object' && sourceAssociate.professionalData.professionalExerciseType !== null) {
            associate.professionalData.professionalExerciseType = getTranslatedTypeWorkOption(sourceAssociate.professionalData.professionalExerciseType.code, language);
        }
    
        if(typeof sourceAssociate.professionalData.weeklyHours !== 'object' && sourceAssociate.professionalData.weeklyHours !== null) {
            associate.professionalData.weeklyHours = { name: sourceAssociate.professionalData.weeklyHours, code: sourceAssociate.professionalData.weeklyHours };
        }
        else if (typeof sourceAssociate.professionalData.weeklyHours === 'object' && sourceAssociate.professionalData.weeklyHours !== null) {
            associate.professionalData.weeklyHours = getTranslatedNumHoursOption(sourceAssociate.professionalData.weeklyHours.code, language);
        }
    
        if(typeof sourceAssociate.professionalData.workplacesNumber !== 'object' && sourceAssociate.professionalData.workplacesNumber !== null) {
            associate.professionalData.workplacesNumber = { name: sourceAssociate.professionalData.workplacesNumber, code: sourceAssociate.professionalData.workplacesNumber };
        }
        else if (typeof sourceAssociate.professionalData.workplacesNumber === 'object' && sourceAssociate.professionalData.workplacesNumber !== null) {
            associate.professionalData.workplacesNumber = getTranslatedNumWorkplacesOption(sourceAssociate.professionalData.workplacesNumber.code, language);
        }
    
        if(sourceAssociate.professionalData.secondaryActivityContext !== null) {
            let activities = Array.isArray(sourceAssociate.professionalData.secondaryActivityContext) ? sourceAssociate.professionalData.secondaryActivityContext : sourceAssociate.professionalData.secondaryActivityContext.split(',');
            
            associate.professionalData.secondaryActivityContext = [];
    
            for (let i = 0; i < activities.length; i++) {
                associate.professionalData.secondaryActivityContext.push(activities[i]);  // { code: activities[i], name: activities[i] }
            }
        }
    
        if(sourceAssociate.professionalData.clinicActivity !== null) {
            const src = sourceAssociate.professionalData.clinicActivity;
            CA_PROPS.forEach(prop => {
                const key = `${prop}Activities`;
                const rawValues = src[key] === null ? []
                    : Array.isArray(src[key]) ? src[key]
                    : (src[prop] ? src[prop].split(',') : []);
                associate.professionalData.clinicActivity[key] = rawValues.map(v => ({ name: v, code: v }));
            });
        }
        else {
            associate.professionalData.clinicActivity = {};
            CA_PROPS.forEach(prop => {
                associate.professionalData.clinicActivity[`${prop}Activities`] = [];
            });
        }
    
        return associate;
    }

  render() {
    return (
        this.props.associate !== null && this.props.associate.professionalData !== null && this.state.professionalExperience !== null && this.state.hasClinicActivity !== null && this.state.secondaryActivity !== null ? 
            <div className='grid mgb-80'>
                <Tooltip target=".professional-data-help-icon" />
                <div className='col-12'>
                    <div className="card p-fluid mgt-20">
                        <div className='grid'>
                            <div className='col-12 t-align-right'>
                                {
                                    this.state.readOnlyMode === true ? 
                                        <Button icon="pi pi-pencil" className="p-button-rounded mr-2 mb-2" disabled={!this.props.registrationApproved} onClick={() => this.activateEditMode()} />
                                        :   
                                        <>
                                            <Button icon="pi pi-check" className="p-button-rounded p-button-success mr-2 mb-2" onClick={() => this.saveChanges()} />
                                            <Button icon="pi pi-ban" className="p-button-rounded p-button-danger mr-2 mb-2" onClick={() => this.cancelEditMode()} />
                                        </>
                                }
                            </div>  
                            {
                                this.state.readOnlyMode ? 
                                    <div className='col-12 t-align-left'>
                                        <label htmlFor="hasProfessionalExperience">{this.props.t("profile.areas.professional.previous-experience")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="hasProfessionalExperience" value={this.state.professionalExperience} disabled={true} options={getYesNoDropdownList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("professionalExperience", evt.value)}></Dropdown>
                                    </div>
                                    : null
                            }
                            {
                                !this.state.readOnlyMode ? 
                                    <div className='col-12 t-align-left'>
                                        <label htmlFor="hasProfessionalExperience">{this.props.t("profile.areas.professional.previous-experience")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="hasProfessionalExperience" value={this.state.professionalExperience} disabled={false/*this.state.professionalExperience.code === YES_OPTION.code*/} options={getYesNoDropdownList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("professionalExperience", evt.value)}></Dropdown>
                                    </div>
                                    : null
                            }
                            <div className='col-12 t-align-left'>
                                <span>
                                    <b className='mgr-5'>{this.props.t("profile.areas.professional.professional-place")}</b>
                                    <i className="professional-data-help-icon pi pi-question-circle p-text-secondary" data-pr-tooltip={this.props.t("profile.areas.professional.help-messages.professional-address")} data-pr-position="right" data-pr-at="right+5 center" data-pr-my="left center-2" style={{ color:"#0073aa", fontSize:"16px", fontWeight:"bold", cursor: 'pointer' }}></i>
                                </span>
                            </div>
                            <div className='col-12 t-align-left'>
                                <label htmlFor="entity">{this.props.t("profile.areas.professional.entity")}<span className="invalid-message">*</span></label>
                                <InputText id="entity" value={this.state.entity} disabled={this.state.readOnlyMode} type="text" onChange={(evt) => this.updateFormComponent("entity", evt.target.value)}/>
                                { this.state.validEntity ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                            </div>
                            <div className='col-12 md:col-12 lg:col-2 t-align-left'>
                                <label htmlFor="streetType">{this.props.t("profile.areas.professional.street-type")}</label>
                                <Dropdown showClear={true} value={this.state.streetType} disabled={this.state.readOnlyMode} id="streetType" options={STREET_TYPE_LIST} optionLabel="name" onChange={(evt) => this.updateFormComponent("streetType", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="professionalAddress1">{this.props.t("profile.areas.professional.address-line")} <span className="invalid-message">*</span></label>
                                <InputText id="professionalAddress1" maxLength="100" value={this.state.addressLine} disabled={this.state.readOnlyMode} type="text" onChange={(evt) => this.updateFormComponent("addressLine", evt.target.value)}/>
                                { this.state.validAddressLine ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                            </div>
                            {
                                /*
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <label htmlFor="professionalAddress2">{this.props.t("profile.areas.professional.address-line-2")}</label>
                                        <InputText id="professionalAddress2" value={this.state.addressLine2} disabled={this.state.readOnlyMode} type="text" onChange={(evt) => this.updateFormComponent("addressLine2", evt.target.value)}/>
                                    </div>
                                */
                            }
                            <div className='col-12 md:col-12 lg:col-1 t-align-left'>
                                <label htmlFor="doorNumber">{this.props.t("profile.areas.professional.door-number")} <span className="invalid-message">*</span></label>
                                <InputText value={this.state.doorNumber} disabled={this.state.readOnlyMode} id="doorNumber" type="text" onChange={(evt) => this.updateFormComponent("doorNumber", evt.target.value)} />
                                { this.state.validDoorNumber ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                            </div>
                            <div className='col-12 md:col-12 lg:col-1 t-align-left'>
                                <label htmlFor="doorFloor">{this.props.t("profile.areas.professional.door-floor")}</label>
                                <InputText value={this.state.doorFloor} disabled={this.state.readOnlyMode} id="doorFloor" type="text" onChange={(evt) => this.updateFormComponent("doorFloor", evt.target.value)} />
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="auxPlace">{this.props.t("profile.areas.professional.aux-place")}</label>
                                <InputText value={this.state.auxPlace} disabled={this.state.readOnlyMode} id="auxPlace" type="text" onChange={(evt) => this.updateFormComponent("auxPlace", evt.target.value)} />
                            </div>
                            <div className='col-6 md:col-6 lg:col-2 t-align-left'>
                                <label htmlFor="cp4">{this.props.t("profile.areas.professional.postal-code")} <span className="invalid-message">*</span></label>
                                <InputText id="cp4" value={this.state.cP4} disabled={this.state.readOnlyMode} type="text" pattern="\d*" maxLength="4" onChange={(evt) => this.updateFormComponent("cP4", evt.target.value)}/>
                                { this.state.validCp ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                { this.state.validCpFormat ? null : <small className="p-error">{this.props.t("general.wrong-cp-format")}</small>  }
                            </div>
                            <div className='col-5 md:col-5 lg:col-1 t-align-left mgt-16'>
                                <InputText id="cp3" value={this.state.cP3} disabled={this.state.readOnlyMode} type="text" pattern="\d*" maxLength="3" onChange={(evt) => this.updateFormComponent("cP3", evt.target.value)}/>
                            </div>
                            <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                <label htmlFor="professionalCity">{this.props.t("profile.areas.professional.city")} <span className="invalid-message">*</span></label>
                                <InputText id="professionalCity" value={this.state.city} disabled={this.state.readOnlyMode} type="text" onChange={(evt) => this.updateFormComponent("city", evt.target.value)}/>
                                { this.state.validCity ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                            </div>
                            <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                <label htmlFor="professionalCounty">{this.props.t("profile.areas.professional.council")} <span className="invalid-message">*</span></label>
                                <Dropdown id="professionalCounty" value={this.state.county} disabled={this.state.readOnlyMode} options={COUNCIL_LIST} optionLabel="name" onChange={(evt) => this.updateFormComponent("county", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                <label htmlFor="professionalDistrict">{this.props.t("profile.areas.professional.district")} <span className="invalid-message">*</span></label>
                                <Dropdown id="professionalDistrict" value={this.state.district} disabled={true} options={DISTRICT_LIST} optionLabel="name"></Dropdown>
                            </div>
                            {
                                this.state.professionalExperience.code === YES_OPTION.code ?
                                    <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                        <label htmlFor="mainActivity">{this.props.t("profile.areas.professional.main-activity")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="mainActivity" value={this.state.mainActivity} disabled={this.state.readOnlyMode} options={getMainActivityList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("mainActivity", evt.value)}></Dropdown>
                                        { this.state.validMainActivity ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small> }
                                    </div>
                                    : null
                            }
                            {
                                this.state.professionalExperience.code === YES_OPTION.code ?
                                    <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                        <label htmlFor="mainActivityType">{this.props.t("profile.areas.professional.main-activity-contract")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="mainActivityType" value={this.state.mainActivityContract} disabled={this.state.readOnlyMode} options={getMainActivityContractList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("mainActivityContract", evt.value)}></Dropdown>
                                        { this.state.validMainActivityContract ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small> }
                                    </div>
                                    : null
                            }
                            {
                                this.state.professionalExperience.code === YES_OPTION.code ?
                                    <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                        <label htmlFor="mainActivityContext">{this.props.t("profile.areas.professional.main-activity-context")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="mainActivityContext" value={this.state.mainActivityContext} disabled={this.state.readOnlyMode} options={getMainActivityContextList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("mainActivityContext", evt.value)}></Dropdown>
                                        { this.state.validMainActivityContext ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small> }
                                    </div>
                                    : null
                            }
                            {
                                this.state.professionalExperience.code === YES_OPTION.code ?
                                    <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                        <label htmlFor="mainActivityArea">{this.props.t("profile.areas.professional.main-activity-area")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="mainActivityArea" value={this.state.mainActivityArea} disabled={this.state.readOnlyMode} options={getPhysioPostGradAreaList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("mainActivityArea", evt.value)}></Dropdown>
                                        { this.state.validMainActivityArea ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small> }
                                    </div>
                                    : null
                            }
                            {
                                this.state.professionalExperience.code === YES_OPTION.code ?
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <label htmlFor="hasSecondaryActivity">{this.props.t("profile.areas.professional.secondary-activity")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="hasSecondaryActivity" value={this.state.secondaryActivity} disabled={this.state.readOnlyMode} options={getYesNoDropdownList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("secondaryActivity", evt.value)}></Dropdown>
                                    </div>
                                    : null
                            }
                            {
                                this.state.professionalExperience.code === YES_OPTION.code &&
                                this.state.secondaryActivity.code === YES_OPTION.code ?
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <label htmlFor="secondaryActivityContext">{this.props.t("profile.areas.professional.secondary-activity-context")} <span className="invalid-message">*</span></label>
                                        <MultiSelect id="secondaryActivityContext" value={this.state.secondaryActivityContext} disabled={this.state.readOnlyMode} options={SECONDARY_ACTIVITY_CONTEXT} optionLabel="name" optionValue="code" placeholder="Selecione uma ou mais opções"  onChange={(evt) => this.updateFormComponent("secondaryActivityContext", evt.value)} />
                                        { this.state.validSecondaryActivityContext ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                    </div>
                                    : null
                            }
                            {
                                this.state.professionalExperience.code === YES_OPTION.code ?
                                    <div className='col-12 t-align-left'>
                                        <label htmlFor="hasClinicActivity">{this.props.t("profile.areas.professional.clinic-activity")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="hasClinicActivity" value={this.state.hasClinicActivity} disabled={this.state.readOnlyMode} options={getYesNoDropdownList(getLanguage())} optionLabel="name"  onChange={(evt) => this.updateFormComponent("hasClinicActivity", evt.value)}></Dropdown>
                                    </div>
                                    : null
                            }
                            {
                                this.state.professionalExperience.code === YES_OPTION.code && 
                                this.state.hasClinicActivity.code === YES_OPTION.code ?
                                    <div className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                        <div className='grid'>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="cardioRespiratory">{this.props.t("profile.areas.professional.cardio-respiratory")}</label>
                                                <MultiSelect id="cardioRespiratory" value={this.state.clinicActivity.cardioRespiratoryActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("cardioRespiratoryActivities", evt.value)}/>
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="muscleHealth">{this.props.t("profile.areas.professional.muscle-health")}</label>
                                                <MultiSelect id="muscleHealth" value={this.state.clinicActivity.muscleHealthActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("muscleHealthActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="muscleAmputees">{this.props.t("profile.areas.professional.muscle-amputees")}</label>
                                                <MultiSelect id="muscleAmputees" value={this.state.clinicActivity.muscleAmputeesActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("muscleAmputeesActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="muscleTMJ">{this.props.t("profile.areas.professional.muscle-tmj")}</label>
                                                <MultiSelect id="muscleTMJ" value={this.state.clinicActivity.muscleTMJActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("muscleTMJActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="neuroHealth">{this.props.t("profile.areas.professional.neuro-health")}</label>
                                                <MultiSelect id="neuroHealth" value={this.state.clinicActivity.neuroHealthActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("neuroHealthActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="neuroVestibular">{this.props.t("profile.areas.professional.neuro-vestibular")}</label>
                                                <MultiSelect id="neuroVestibular" value={this.state.clinicActivity.neuroVestibularActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("neuroVestibularActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="dermaHealth">{this.props.t("profile.areas.professional.derma-health")}</label>
                                                <MultiSelect id="dermaHealth" value={this.state.clinicActivity.dermaHealthActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("dermaHealthActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="mentalHealth">{this.props.t("profile.areas.professional.mental-health")}</label>
                                                <MultiSelect id="mentalHealth" value={this.state.clinicActivity.mentalHealthActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("mentalHealthActivities", evt.value)}/>
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="womensHealth">{this.props.t("profile.areas.professional.womens-health")}</label>
                                                <MultiSelect id="womensHealth" value={this.state.clinicActivity.womensHealthActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("womensHealthActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="pelvicHealth">{this.props.t("profile.areas.professional.pelvic-health")}</label>
                                                <MultiSelect id="pelvicHealth" value={this.state.clinicActivity.pelvicHealthActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("pelvicHealthActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="sportsHealth">{this.props.t("profile.areas.professional.sports-health")}</label>
                                                <MultiSelect id="sportsHealth" value={this.state.clinicActivity.sportsHealthActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("sportsHealthActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="oncology">{this.props.t("profile.areas.professional.oncology")}</label>
                                                <MultiSelect id="oncology" value={this.state.clinicActivity.oncologyActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("oncologyActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="palliativeCare">{this.props.t("profile.areas.professional.palliative-care")}</label>
                                                <MultiSelect id="palliativeCare" value={this.state.clinicActivity.palliativeCareActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("palliativeCareActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="occupational">{this.props.t("profile.areas.professional.occupational")}</label>
                                                <MultiSelect id="occupational" value={this.state.clinicActivity.occupationalActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("occupationalActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="emergencyDisaster">{this.props.t("profile.areas.professional.emergency-disaster")}</label>
                                                <MultiSelect id="emergencyDisaster" value={this.state.clinicActivity.emergencyDisasterActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("emergencyDisasterActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="animalHealth">{this.props.t("profile.areas.professional.animal-health")}</label>
                                                <MultiSelect id="animalHealth" value={this.state.clinicActivity.animalHealthActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("animalHealthActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="publicHealth">{this.props.t("profile.areas.professional.public-health")}</label>
                                                <MultiSelect id="publicHealth" value={this.state.clinicActivity.publicHealthActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("publicHealthActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="communityHealth">{this.props.t("profile.areas.professional.community-health")}</label>
                                                <MultiSelect id="communityHealth" value={this.state.clinicActivity.communityHealthActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("communityHealthActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="schoolHealth">{this.props.t("profile.areas.professional.school-health")}</label>
                                                <MultiSelect id="schoolHealth" value={this.state.clinicActivity.schoolHealthActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("schoolHealthActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="pediatrics">{this.props.t("profile.areas.professional.pediatrics")}</label>
                                                <MultiSelect id="pediatrics" value={this.state.clinicActivity.pediatricsActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("pediatricsActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="gerontology">{this.props.t("profile.areas.professional.gerontology")}</label>
                                                <MultiSelect id="gerontology" value={this.state.clinicActivity.gerontologyActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("gerontologyActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="pain">{this.props.t("profile.areas.professional.pain")}</label>
                                                <MultiSelect id="pain" value={this.state.clinicActivity.painActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("painActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="intensiveCare">{this.props.t("profile.areas.professional.intensive-care")}</label>
                                                <MultiSelect id="intensiveCare" value={this.state.clinicActivity.intensiveCareActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("intensiveCareActivities", evt.value)} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="healthProtection">{this.props.t("profile.areas.professional.health-protection")}</label>
                                                <MultiSelect id="healthProtection" value={this.state.clinicActivity.healthProtectionActivities} disabled={this.state.readOnlyMode} options={CLINIC_ACTIVITY_LIST} optionLabel="name" placeholder="Selecione uma ou mais opções" onChange={(evt) => this.updateClinicActivityFormComponent("healthProtectionActivities", evt.value)} />
                                            </div>
                                            { !this.state.validClinicActivity ? <div className='col-12 t-align-left'><small className="p-error">{this.props.t("general.mandatory-field")}</small></div> : null }
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                this.state.professionalExperience.code === YES_OPTION.code ?
                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                        <label htmlFor="professionalType">{this.props.t("profile.areas.professional.professional-type")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="professionalType" value={this.state.professionalExerciseType} disabled={this.state.readOnlyMode} options={getTypeWorkList(getLanguage())} optionLabel="name"  onChange={(evt) => this.updateFormComponent("professionalExerciseType", evt.value)}></Dropdown>
                                        { this.state.validProfessionalExerciseType ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small> }
                                    </div>
                                    : null
                            }
                            {
                                this.state.professionalExperience.code === YES_OPTION.code ?
                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                        <label htmlFor="professionalWorkplaces">{this.props.t("profile.areas.professional.professional-workplaces")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="professionalWorkplaces" value={this.state.workplacesNumber} disabled={this.state.readOnlyMode} options={getNumWorkspacesList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("workplacesNumber", evt.value)}></Dropdown>
                                        { this.state.validWorkplacesNumber ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small> }
                                    </div>
                                    : null
                            }
                            {
                                this.state.professionalExperience.code === YES_OPTION.code ?
                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                        <label htmlFor="professionalNumHours">{this.props.t("profile.areas.professional.professional-num-hours")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="professionalNumHours" value={this.state.weeklyHours} disabled={this.state.readOnlyMode} options={getNumHoursList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("weeklyHours", evt.value)}></Dropdown>
                                        { this.state.validWeeklyHours ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small> }
                                    </div>
                                    : null
                            }
                             <div className='col-12'><hr/></div>
                            {
                                this.state.compProfessionalDoc !== null ?  
                                    <div className='col-12 md:col-12 lg:col-3 t-align-left'>                                       
                                        <span onClick={() => this.downloadDocument(this.state.compProfessionalDoc.nodeRef)}>
                                            <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.professional.documents.comp-professional")} icon="pi pi-download" className="mr-2 mb-2" />
                                        </span>
                                    </div>
                                    : null
                            }
                            {
                                this.state.professionalExperience.code === YES_OPTION.code && this.state.readOnlyMode === false ?
                                    <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                        <FileUpload mode="basic" 
                                                    accept="application/pdf" 
                                                    chooseLabel={this.props.t("profile.areas.professional.upload-comp-professional")}
                                                    maxFileSize={1000000} 
                                                    uploadHandler={(evt) => this.uploadDocumentHandler(evt.files, 'comp_professional')} customUpload={true} auto={true}
                                                    onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                                        {
                                            this.state.compProfessionalAttachment !== null ? 
                                                <span>{this.state.compProfessionalAttachmentName}</span> : null
                                        }
                                    </div>
                                    : null
                            }
                            {
                                this.state.goodStandingDoc !== null ?
                                    <div className='col-12 md:col-12 lg:col-3 t-align-left'> 
                                        <span className={isMobileOnly ? '' : 'mgl-10'} onClick={() => this.downloadDocument(this.state.goodStandingDoc.nodeRef)}>
                                            <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.professional.documents.good-standing")} icon="pi pi-download" className="mr-2 mb-2" />
                                        </span>
                                    </div>
                                    : null
                            }
                            {
                                this.state.professionalExperience.code === YES_OPTION.code && this.state.readOnlyMode === false ?
                                    <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                        <FileUpload mode="basic" 
                                                    accept="application/pdf" 
                                                    chooseLabel={this.props.t("profile.areas.professional.upload-good-standing")}
                                                    maxFileSize={1000000} 
                                                    uploadHandler={(evt) => this.uploadDocumentHandler(evt.files, 'good_standing')} customUpload={true} auto={true}
                                                    onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                                        {
                                            this.state.goodStandingAttachment !== null ? 
                                                <span>{this.state.goodStandingAttachmentName}</span> : null
                                        }
                                    </div>
                                    : null
                            }
                            { this.state.validUploadFile ? null : <div className='col-12 t-align-left'><small className="p-error">{this.props.t("profile.areas.professional.invalid-file")}</small></div>  }
                            { this.state.validCompProfessionalDoc ? null : <div className='col-12 t-align-left'><small className="p-error">{this.props.t("general.mandatory-field")}</small></div>  }
                        </div>
                    </div>
                </div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
            : null
    );
  }
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        registrationDocs: state.profile.registrationDocs,
        registrationRef: state.authentication.registrationRef,
        registrationApproved: state.authentication.registrationApproved,
        language: state.profile.language
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        setEditMode: (editMode) => { dispatch(setEditMode(editMode)) },
        getAssociateData: (registrationRef) => { dispatch(getAssociateData(registrationRef)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(ProfessionalDataComponent));